function fixFrontZero(num: number): string {
    return num > 10 ? num + '' : '0' + num;
}

interface IDisplayTime {
    date: Date;
    hour: number;
    minute: number;
}

export default {
    utc2gmt(utcTime: string): Date {
        return new Date(utcTime.slice(0, 19));
    },

    gmtTime2Display(gmtTime: Date): IDisplayTime {
        return {
            date: gmtTime,
            hour: gmtTime.getHours(),
            minute: gmtTime.getMinutes()
        };
    },

    utcTime2Display(utcTime: string): IDisplayTime {
        const gmtTime = this.utc2gmt(utcTime);
        return this.gmtTime2Display(gmtTime);
    },

    displayTime2Utc(displayTime: IDisplayTime): string {
        let gmtTime = displayTime.date;
        gmtTime.setHours(displayTime.hour);
        gmtTime.setMinutes(displayTime.minute);
        gmtTime.setSeconds(0);
        let utcTime = gmtTime.getTime();
        utcTime = gmtTime.getTime() + (gmtTime.getTimezoneOffset() * 60000);
        gmtTime = new Date(utcTime);
        const y = gmtTime.getFullYear();
        const M = gmtTime.getMonth() + 1;
        const d = gmtTime.getDate();
        const h = gmtTime.getHours();
        const m = gmtTime.getMinutes();
        // tslint:disable-next-line: max-line-length
        const utcString = y + '-' + fixFrontZero(M) + '-' + fixFrontZero(d) + 'T' + fixFrontZero(h) + ':' + fixFrontZero(m) + ':00.0000000Z';
        return utcString;
    }
}